'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _extends2 = require('babel-runtime/helpers/extends');
var _extends3 = _interopRequireDefault(_extends2);
var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');
var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');
var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');
var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
var _createClass2 = require('babel-runtime/helpers/createClass');
var _createClass3 = _interopRequireDefault(_createClass2);
var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');
var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
var _inherits2 = require('babel-runtime/helpers/inherits');
var _inherits3 = _interopRequireDefault(_inherits2);
var _classnames = require('classnames');
var _classnames2 = _interopRequireDefault(_classnames);
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
require('./icons.scss');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

/* eslint-disable */
var American = function (_PureComponent) {
  (0, _inherits3.default)(American, _PureComponent);
  function American() {
    (0, _classCallCheck3.default)(this, American);
    return (0, _possibleConstructorReturn3.default)(this, (American.__proto__ || (0, _getPrototypeOf2.default)(American)).apply(this, arguments));
  }
  (0, _createClass3.default)(American, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
        className = _props.className,
        otherProps = (0, _objectWithoutProperties3.default)(_props, ['className']);
      return _react2.default.createElement('svg', (0, _extends3.default)({
        viewBox: '0 0 32 32',
        style: {
          width: '1em',
          height: '1em'
        },
        preserveAspectRatio: 'xMidYMid meet'
      }, otherProps, {
        className: (0, _classnames2.default)('sb-icon-svg', className),
        xmlns: 'http://www.w3.org/2000/svg'
      }), _react2.default.createElement('path', {
        d: 'M7.347 17.073h-2.61v3.465H2.61v-3.465H0v-2.13h2.61V11.48h2.128v3.464h2.61v2.13zm2.256 3.2H14.3v2.005H6.556v-1.816l3.862-4.947c.445-.57.772-1.1.98-1.586s.314-1.01.314-1.567c0-.807-.153-1.392-.46-1.753s-.8-.543-1.48-.543c-.933 0-1.9.21-2.902.626V8.606C7.844 8.202 8.95 8 10.19 8c1.418 0 2.46.33 3.12.992s.992 1.7.992 3.12c0 .752-.136 1.47-.407 2.15s-.685 1.38-1.242 2.088l-3.047 3.924zM22.94 8.25v1.712l-4.3 12.315h-2.504l4.342-12.023h-5.24V8.25h7.703zm8.08 6.596c.653.682.98 1.78.98 3.298 0 1.545-.376 2.66-1.127 3.35s-1.983 1.033-3.695 1.033c-1.072 0-2.066-.174-2.985-.522V20a6.97 6.97 0 0 0 2.776.565c.862 0 1.488-.195 1.878-.584s.584-1.022.584-1.898c0-.863-.205-1.48-.616-1.847s-1.082-.553-2.014-.553c-.807 0-1.58.05-2.317.146V8.25h7.347l-1.232 1.9h-3.84v3.715c.5-.028.87-.042 1.105-.042 1.447 0 2.498.34 3.152 1.023z'
      }));
    }
  }]);
  return American;
}(_react.PureComponent);
American.propTypes = {
  className: _propTypes.PropTypes.string
};
exports.default = American;